/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LogAttendanceResponse
 */
export interface LogAttendanceResponse {
    /**
     * 
     * @type {string}
     * @memberof LogAttendanceResponse
     */
    logId: string;
}

/**
 * Check if a given object implements the LogAttendanceResponse interface.
 */
export function instanceOfLogAttendanceResponse(value: object): value is LogAttendanceResponse {
    if (!('logId' in value) || value['logId'] === undefined) return false;
    return true;
}

export function LogAttendanceResponseFromJSON(json: any): LogAttendanceResponse {
    return LogAttendanceResponseFromJSONTyped(json, false);
}

export function LogAttendanceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogAttendanceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'logId': json['logId'],
    };
}

export function LogAttendanceResponseToJSON(json: any): LogAttendanceResponse {
    return LogAttendanceResponseToJSONTyped(json, false);
}

export function LogAttendanceResponseToJSONTyped(value?: LogAttendanceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'logId': value['logId'],
    };
}

